import * as React from "react"
import { ChevronDownIcon } from "lucide-react"

import { cn } from "@/lib/utils"

/**
 * Select nativo SIN caja: solo el valor en negrita y su flecha. Es el control de
 * una barra de filtros donde el contenedor ya pone el borde (`FiltroDePersona`) o
 * donde el valor flota junto a su rótulo ("Ordenar por · fecha de creación").
 *
 * Es nativo a propósito, como `NativeSelect`: el sistema operativo dibuja el
 * menú. El nombre accesible NO se deduce del valor puesto, así que `aria-label`
 * o un `<label>` son obligatorios en quien lo usa.
 */
function SelectSinBorde({ className, children, ...props }: React.ComponentProps<"select">) {
  return (
    <span className="relative inline-flex items-center">
      <select
        data-slot="select-sin-borde"
        className={cn(
          "text-ink h-[2.125rem] max-w-[12.5rem] cursor-pointer appearance-none rounded-md bg-transparent py-0 pr-5 pl-1 text-[0.78125rem] font-bold outline-none",
          "focus-visible:ring-ring/50 focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDownIcon
        aria-hidden
        className="text-ink-muted pointer-events-none absolute right-0.5 size-3.5"
      />
    </span>
  )
}

export { SelectSinBorde }
